export default __webpack_public_path__ + "static/media/back.4849f5e8.webp";